import Article from './components/Article';

export default Article;
